import { minValue, number, regex, required, TextInput } from "react-admin";
import React from "react";

interface ICustomNumberInput {
  label: string;
  source: string;
  defaultValue?: number;
  isRequired?: boolean;
  isPositiveValue?: boolean;
  isDisabled?: boolean;
  onChange?: any;
}

const CustomNumberInput = ({
  label,
  source,
  defaultValue,
  isRequired,
  isPositiveValue,
  onChange,
  isDisabled = false,
}: ICustomNumberInput) => {
  let validate = [number(), regex(/^-?\d+(?:\.\d{1,2})?$/)];

  if (isRequired) {
    validate.push(required());
  }

  if (isPositiveValue) {
    validate.push(minValue(0));
  }

  return (
    <TextInput
      label={label}
      source={source}
      validate={validate}
      disabled={isDisabled}
      defaultValue={defaultValue}
      onChange={onChange}
    />
  );
};

export default CustomNumberInput;
